import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPage } from "@/lib/track";

export function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    trackPage(location.pathname + location.search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
  return null;
}
